import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-28552d7e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "user-details__name" };
const _hoisted_2 = { class: "dark-mode" };
const _hoisted_3 = { class: "dark-mode__inner" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Dark Mode", -1));
const _hoisted_5 = /*#__PURE__*/ _createTextVNode(" Change Details ");
const _hoisted_6 = /*#__PURE__*/ _createTextVNode("Logout");
import { MoonIcon, SunIcon } from "@heroicons/vue/outline";
import { createPopper } from "@popperjs/core";
import { computed, onMounted, ref } from "vue";
import { useAuthentication } from "@/stores/authentication";
import { useDarkMode } from "@/stores/dark-mode";
import Avatar from "@/components/Avatar.vue";
import Button from "@/components/Button.vue";
import { storeToRefs } from "pinia";
import { Teleport as teleport_ } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const darkMode = useDarkMode();
        const authState = useAuthentication();
        const { currentUser } = storeToRefs(authState);
        const popperTarget = ref();
        const popperMenu = ref();
        const openMenu = ref(false);
        const { isDarkMode } = storeToRefs(darkMode);
        const popper = ref();
        const className = computed(() => ["user-details__menu", openMenu.value ? "user-details__menu--open" : ""]
            .filter((c) => c)
            .join(" "));
        const Teleport = teleport_;
        const open = () => {
            openMenu.value = !openMenu.value;
            popper.value?.update();
        };
        onMounted(() => {
            window.requestAnimationFrame(() => {
                if (popperTarget.value !== undefined && popperMenu.value !== undefined) {
                    popper.value = createPopper(popperTarget.value, popperMenu.value, {
                        placement: "bottom-end",
                        modifiers: [
                            {
                                name: "offset",
                                options: { offset: [0, 6] },
                            },
                        ],
                    });
                }
            });
        });
        return (_ctx, _cache) => {
            const _component_RouterLink = _resolveComponent("RouterLink");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    class: "user-details",
                    onClickPassive: _cache[0] || (_cache[0] = ($event) => (openMenu.value = !openMenu.value)),
                    ref_key: "popperTarget",
                    ref: popperTarget
                }, [
                    _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(currentUser)?.name), 1),
                    _createVNode(Avatar, {
                        name: _unref(currentUser)?.name,
                        src: _unref(currentUser)?.avatar_uri,
                        size: "10"
                    }, null, 8, ["name", "src"])
                ], 544),
                (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(Teleport)), { to: "body" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", {
                            class: _normalizeClass(_unref(className)),
                            ref_key: "popperMenu",
                            ref: popperMenu
                        }, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _hoisted_4,
                                    _createVNode(Button, {
                                        onClickPassive: _unref(darkMode).toggleDarkMode,
                                        variant: _unref(isDarkMode) ? 'dark' : 'light'
                                    }, {
                                        default: _withCtx(() => [
                                            _withDirectives(_createVNode(_unref(MoonIcon), {
                                                class: _normalizeClass(`${_unref(isDarkMode) ? '' : 'hidden '}icon`)
                                            }, null, 8, ["class"]), [
                                                [_vShow, _unref(isDarkMode)]
                                            ]),
                                            _createVNode(_unref(SunIcon), {
                                                class: _normalizeClass(`${_unref(isDarkMode) ? 'hidden ' : ''}icon`)
                                            }, null, 8, ["class"])
                                        ]),
                                        _: 1
                                    }, 8, ["onClickPassive", "variant"])
                                ]),
                                _createElementVNode("a", {
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(
                                    //@ts-ignore
                                    (...args) => (_unref(darkMode).resetDarkMode && _unref(darkMode).resetDarkMode(...args)), ["prevent"]))
                                }, "Respect OS Choice")
                            ]),
                            (_unref(currentUser)?.id)
                                ? (_openBlock(), _createBlock(_component_RouterLink, {
                                    key: 0,
                                    to: {
                                        name: 'employees.view',
                                        params: { id: _unref(currentUser)?.id },
                                    }
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_5
                                    ]),
                                    _: 1
                                }, 8, ["to"]))
                                : _createCommentVNode("", true),
                            _createVNode(_component_RouterLink, { to: { name: 'auth.logout' } }, {
                                default: _withCtx(() => [
                                    _hoisted_6
                                ]),
                                _: 1
                            }, 8, ["to"])
                        ], 2)
                    ]),
                    _: 1
                }))
            ], 64));
        };
    }
});
